import React, { useRef, useState } from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { IFXFile } from "../../../components/AppComponents/IFXFile";
import { IFXButton } from "../../../components/AppComponents/IFXButton";
import { IFXFieldWrapper } from "../../../components/AppComponents";

export const FileCard = () => {
  const fileRef = useRef(null);
  const file2Ref = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [multiSelectedFiles, setMultiSelectedFiles] = useState([]);

  const validateFileSize = uploadedFile => {
    let size = 5000000;
    if (uploadedFile && uploadedFile.size > size) {
      return false;
    }
    return true;
  };

  const onFileUpload = () => {
    console.log("onFileUpload>selectedFile>>", selectedFile);
    if (validateFileSize(selectedFile)) {
      alert(`'${selectedFile?.name}'>>>File is uploaded`);
    } else {
      alert(`'${selectedFile?.name}'>>>File Size is too large`);
    }
  };

  const onFileChange = () => {
    const uploadedFile = fileRef.current.files[0];
    setSelectedFile(uploadedFile);
  };

  const onFileChangeMultiple = (e, files) => {
    setMultiSelectedFiles(currFiles => {
      const currFileNames = currFiles.map(f => f.file.name);
      let _files = files
        .filter(file => !currFileNames.includes(file.name))
        .map(file => ({ file, uploaded: true, uploadProgress: 100 }));
      return [...currFiles, ..._files];
    });
  };

  console.log("multiSelectedFiles", multiSelectedFiles);

  return (
    <Card className="main-card mb-3">
      <Card.Body>
        <Container>
          <Card.Title>File Upload</Card.Title>
          <Row>
            <Col>
              <IFXFieldWrapper label="My File Upload" alwaysFloat>
                <IFXFile ref={fileRef} onChange={onFileChange} />
              </IFXFieldWrapper>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className="d-flex justify-content-end">
              <IFXButton name="Upload" onClick={onFileUpload} />
            </Col>
          </Row>
          <Card.Title className="mt-3">File Upload Multiple</Card.Title>
          <Row>
            <Col>
              <IFXFieldWrapper label="My File Upload Multiple" alwaysFloat>
                <IFXFile
                  multiple
                  ref={file2Ref}
                  onChange={onFileChangeMultiple}
                  selectedFiles={multiSelectedFiles}
                  showUploadProgress
                />
              </IFXFieldWrapper>
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};
